import { render, staticRenderFns } from "./FooterComponentRagtp.vue?vue&type=template&id=1a4c9467&scoped=true"
import script from "./FooterComponentRagtp.vue?vue&type=script&lang=ts"
export * from "./FooterComponentRagtp.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentRagtp.vue?vue&type=style&index=0&id=1a4c9467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c9467",
  null
  
)

export default component.exports